import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { extractExpirationTime, extractUserRole, getTokenFromLocalStorage } from "../CommonService"
import noRefreshClient from "../api/NoRefreshClient"
import UserContext from "../../context/UserContext"

function LoggedInAuthChecker({ children }) {
    const navigate = useNavigate()
    const { clearUserContext, setUserContext } = useContext(UserContext)
    const [authenticated, setAuthenticated] = useState(false)

    useEffect(() => {
        const checkAuthentication = () => {
            // If there is no access token in local storage, deny access
            const token = getTokenFromLocalStorage()
            if (!token) {
                clearUserContext()
                setAuthenticated(false)
                return navigate('/')
            }

            // If the user role is null, deny access
            const role = extractUserRole(token)
            if (!role) {
                clearUserContext()
                setAuthenticated(false)
                return navigate('/')
            }

            // If the token is expired, try to do a token refresh request
            const expiration = extractExpirationTime(token)
            if (!expiration || Date.now() >= expiration * 1000) {
                let headers = {}
                headers['Authorization'] = `Bearer ${token}`

                noRefreshClient.get('refresh', { headers })
                .then(data => {
                    // If successful, allow access
                    setUserContext(data.data.token)
                    setAuthenticated(true)
                })
                .catch(error => {
                    // If the refresh request failed, deny access
                    clearUserContext()
                    setAuthenticated(false)
                    return navigate('/')
                })
            }
            setAuthenticated(true)
        }
        
        checkAuthentication()
    }, [navigate, clearUserContext, setUserContext])

    if (!authenticated) {
        return null
    }
    return (children)

}

export default LoggedInAuthChecker